<div class="content-list">
  @for (content of contentList; track content) {
    <app-content [content]="content" [phaseId]="phaseId"></app-content>
  }
</div>
